import { useState } from 'react'
import type React from 'react'
import { bibleConfig } from '../data/bibleConfig'
import { safeUrl } from '../utils/safeUrl'
import { trackAddToCart } from '../utils/metaPixel'

/** Único botón de la landing que sale hacia el checkout. */
export const BIBLE_PRIMARY_CTA_ID = 'oferta-cta'

interface BibleCheckout {
  /** Href del botón principal (checkout real o ancla de respaldo). */
  purchaseHref: string
  /** Href de los botones secundarios: apuntan al botón principal. */
  secondaryHref: string
  noticeVisible: boolean
  handlePurchaseClick: (event: React.MouseEvent<HTMLAnchorElement>) => void
  handleSecondaryClick: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

function scrollTo(selector: string) {
  document.querySelector(selector)?.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth',
    block: 'center'
  })
}

export function useBibleCheckout(): BibleCheckout {
  const [noticeVisible, setNoticeVisible] = useState(false)
  const checkout = safeUrl(bibleConfig.checkoutUrl)

  const handlePurchaseClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (checkout) {
      trackAddToCart()
      return
    }

    event.preventDefault()
    setNoticeVisible(true)
    scrollTo('#oferta')
  }

  const handleSecondaryClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    scrollTo(`#${BIBLE_PRIMARY_CTA_ID}`)
  }

  return {
    purchaseHref: checkout ?? '#oferta',
    secondaryHref: `#${BIBLE_PRIMARY_CTA_ID}`,
    noticeVisible,
    handlePurchaseClick,
    handleSecondaryClick
  }
}
